var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Production-Plan"},[_c('PageTitle',{attrs:{"imagem":"efetuarplanejamento.png","main":"Efetuar Planejamento da Produção","sub":""}}),_c('ProductionPlanCreatorEditor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }